<template>
  <div class="dialogGroup_cont">
    <div class="dialogGroup_left no_group">
      <ly-tree
        :gpno="areaid"
        :is_superuser="false"
        :area-tree-type="3"
        :showcount="true"
        :displaynoarea="true"
        @treeClick="treeClick"
      />
    </div>

    <div class="dialogGroup_right">
      <div class="Group_right_header">
        <div class="blue_header">
          <span>{{ $t('ifttt.iftttSelect') }}
            <template>
              (<em>{{ iftttData.length }}</em>)
            </template>
          </span>
        </div>

        <div class="ok_group">
          <template v-if="okCheckNum > 0">
            <el-badge
              :value="okCheckNum"
              class="item"
            >
              <button @click="createGrop">
                {{ nextvalue }}
              </button>
            </el-badge>
          </template>
          <template v-else>
            <button @click="createGrop">
              {{ nextvalue }}
            </button>
          </template>
        </div>
      </div>
      <div class="right_card_box ifttt_body">
        <vuescroll>
          <div
            v-loading="loading"
            class="card_box"
            :class="iftttData != null ? (iftttData.length>0 ? '':'card_content_backimage'):''"
          >
            <div class="card-list">
              <div
                v-for="(item,index) in iftttData"
                :key="index"
                class="rhythm-card"
                @click="item.disabled?'':checkIfttt(item,index)"
              >
                <div class="card-top">
                  <div class="top-flex">
                    <div class="card-icon" />
                    <el-checkbox
                      v-show="checkShow"
                      v-model="item.ischecked"
                      class="ifttt_checkbox "
                      :disabled="item.disabled"
                      @change="changebox"
                      @click.stop.native="stopBubble"
                    />
                  </div>
                  <div class="card-title">
                    {{ item.HCLName }}
                  </div>
                </div>
                <div class="card-content">
                  <ul class="card-ul">
                    <li>
                      <span
                        v-if="item.havecheck"
                        class="have_state"
                      >{{ $t('ifttt.selected') }}</span>
                    </li>
                    <li class="card-li">
                      {{ $t('ifttt.status') }}：<span class="font-color">{{ item.ConfigStatus==1?$t('ifttt.success'):item.ConfigStatus==3?$t('ifttt.fail'):$t('ifttt.ing') }}</span>
                    </li>
                    <li class="card-li">
                      <span class="font-color">{{ executionMode(item) }}</span>
                    </li>
                    <li class="card-li">
                      {{ $t('ifttt.time') }}：<span class="font-color">{{ timeOffset(item.CreateTime).split(' ')[0] }}</span>
                    </li>
                    <li class="card-li">
                      {{ $t('ifttt.no') }}：<span class="font-color">{{ item.HCLId }}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </vuescroll>
      </div>
    </div>
  </div>
</template>

<script>
import vuescroll from 'vuescroll';
import vSwith from '@/components/common/switch.vue';
import { alerterror, alertsuccess, warning } from '@/assets/js/common.js';
import { FindHCLList } from '@/axios/IHcl.js';
import {executionMode} from '@/utils/iftttExecute.js'
export default {
  components: {
    vuescroll, vSwith
  },
  props: {   //通过props接收父组件传值
    areaid: {
      type: Number,
      default: -1
    },
    searchtype: {
      type: Number,
      default: 1
    },
    nextText: {
      type: String,
      // default: this.nextvalue
      default() {
        return this.$t('ifttt.yes') || ''
      }
    },
    cardNum: {
      type: Boolean,
      default: true
    },
    checkShow: {
      type: Boolean,
      default: true
    },
    alreadyCheck: {
      type: Array,
      default() {
        return [];
      }
    },
    switchShow: {
      type: Boolean,
      default: true
    }

  },
  data() {
    return {
      loading: false, //是否加载
      okCheckNum: 0, //选中的数量
      filterText: '', //未使用
      allcardNum: 0, //设备总数量
      checkblock: true,//未使用
      checked: false,//未使用
      checked1: false,//未使用
      /* is_click:false, */
      /* checkShow:false, */
      activeColor: '#67c23a', //颜色
      inActiveColor: '', //开关颜色
      active: false,//未使用
      defaultProps: {
        children: 'child',
        label: 'name'
      },//未使用
      nextvalue: this.$t('ifttt.yes'), //下一步描述文字
      iftttData: [], //查询到的自动化
      checkdata: [], //选中的自动化
      isRadio: ''
    };
  },
  created() {
  },
  mounted() {
    this.doFindList(this.areaid);
  },
  methods: {
    executionMode,
    /* 点击触发选择事件
    * event：事件对象
    */
    changebox(event) {
      //disabled
      this.getcheckcount();
    },
    /* 获得选中的ifttt
    */
    getcheckcount() {
      this.okCheckNum = 0;
      this.checkdata = [];
      // this.checkdata.push(this.iftttData[this.isRadio])
      this.iftttData.forEach(n => {
        if (n.ischecked) {
          this.okCheckNum++;
          this.checkdata.push(n);
        }
      })
    },
    /* 点击ifttt触发的事件
    */
    checkIfttt(item, index) {
      item.ischecked = !item.ischecked;
      this.getcheckcount();
    },
    /* 点击树
    */
    treeClick(val) {
      this.doFindList(val[0].id);
    },
    /* 获得区域下ifttt设备
    */
    doFindList(gpno) {
      if (gpno != -1) {
        this.loading = true;
        var para = { gpNo: gpno, loadMode: 0, pageIndex: 1, pageSize: 9999 };//this.searchtype};
        FindHCLList(para, this.functionDoFindList);
        para = null;
      }

    },
    /* 获得区域下ifttt 接口返回数据处理
    * rs：接口返回数据包
    */
    functionDoFindList(rs) {
      this.loading = false;
      this.iftttData = [];
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        if (rs.Result.RecordList) {
          if (rs.Result.RecordList.length > 0) {
            rs.Result.RecordList.forEach(n => {
              var isdel = false;
              for (let i = 0; i < this.alreadyCheck.length; i++) {
                if (this.alreadyCheck[i].ActionType == 8) {
                  if (n.HCLId == this.alreadyCheck[i].HCLId) {
                    isdel = true;
                  }
                }
              }
              n.havecheck = isdel; //是否已选
              n.ischecked = false;
              this.iftttData.push(n);
            })
          }
        }
      }
    },

    stopBubble() {

    },
    /* 点击确定 将选择的iftt提交给调用页面
    */
    createGrop() {
      if (this.checkdata.length > 0) {
        this.$emit('confirm', this.checkdata);
      } else {
        warning(this, this.$t('ifttt.selectHCL'));
      }

    },
  }
};
</script>

<style scoped="scoped" lang="scss">
/* 自动化选择卡片组件	 */
.refresh {
  right: 0px;
}

.ifttt_body {
  .iftt_box {
    .ifttt_list {
      height: 96px;
      background: #9fbcea;

      cursor: pointer;
      .itff_mark {
        &:after {
          border-color: transparent #7b9ed5;
        }
      }
      .switch_text {
        color: #fff;
        .ifttt_title {
          margin-top: 12px;
          padding-bottom: 12px;
          margin-bottom: 8px;

          &:after {
            width: 32px;
            height: 2px;
            background: #fff;
          }
        }
      }
      .ifttt_switch {
        top: 32px;
      }

      .ifttt_checkbox {
        top: 5px;
        height: 0px;
      }
    }
  }
  .ifttt_list {
    background: url(../../assets/img/ift1.png);
    background-repeat: no-repeat;
    background-size: cover;
    cursor: pointer;
    border-radius: 3px;
    position: relative;
    .switch_text {
      color: #2e2e2e;
      position: absolute;
      top: 0px;
      line-height: 1;
    }
    .ifttt_switch {
      position: absolute;
      top: 70px;
    }
    .itff_mark {
      color: #fff;
      position: relative;
      width: 70px;
      height: 70px;
      z-index: 1;

      font-size: 12px;
      &:after {
        position: absolute;
        content: "";
        width: 0px;
        height: 0px;
        border-color: transparent #5d87e8;
        border-width: 0px 0px 70px 70px;
        border-style: solid;
        left: 0px;
        top: 0px;
      }
      i {
        color: #fff;
        z-index: 1;
        font-size: 12px;
        position: absolute;
        top: 8px;
        left: 8px;
      }
      span {
        position: absolute;
        z-index: 1;
        color: #fff;
        width: 75px;
        height: 85px;
        left: 20px;
        top: 5px;
        -webkit-transform: rotate(-45deg);
        -moz-transform: rotate(-45deg);
        -ms-transform: rotate(-45deg);
        -o-transform: rotate(-45deg);
        filter: progid:DXImageTransform.Microsoft.BasicImage(Rotation=0.45);
      }
    }
  }
}
.ifttt_header {
  font-size: 14px;
  background: #fdfdfd;
  height: 105px;
  .ifttt_div {
    display: inline-block;
    color: #181818;
    margin-left: 40px;
    cursor: pointer;
    i {
      color: #88a7eb;
      display: inline-block;
      line-height: 105px;
      float: left;
      margin-right: 8px;
    }
    .icon-7 {
      font-size: 37px;
    }
    .icon-13 {
      font-size: 37px;
    }
    .ifttt_span {
      line-height: 105px;
      em {
        color: #1571ee;
        font-style: normal;
      }
    }
  }
}

.have_tree {
  display: block;
  position: absolute;
  top: 0;
  bottom: 0px;
  height: unset;
}

.card-list {
  display: flex;
  flex-wrap: wrap;
}
.rhythm-card {
  width: 260px;
  border-radius: 3px;
  margin-right: 21px;
  margin-bottom: 21px;
  cursor: pointer;
  border: 1px solid #dde2ea;
  position: relative;
  user-select: none;
  .card-top {
    min-height: 107px;
    color: #fff;
    background: linear-gradient(
      to right,
      rgba(129, 168, 223, 0.2),
      rgba(129, 168, 223, 0.7),
      rgba(129, 168, 223, 0.8),
      rgba(129, 168, 223, 0.9),
      rgba(129, 168, 223, 1)
    );
    .top-flex {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .card-title {
      font-weight: bold;
      font-size: 18px;
      text-align: center;
      margin-top: 20px;
      padding: 0 20px;
    }
    .card-icon {
      width: 46px;
      height: 28px;
      background: url("~@/assets/img/rhythm/line@2x.png") no-repeat 0 0 / 100%
        100%;
    }
  }
  .card-content {
    background: #fff;
    padding: 22px 20px;
    .card-ul {
      display: flex;
      flex-wrap: wrap;
      color: #a8a8a8;
    }
    .card-li:nth-child(2n) {
      width: 114px;
      font-size: 12px;
      margin-bottom: 5px;
      .font-color {
        color: #1f1f1f;
      }
    }
    .card-li:nth-child(2n + 1) {
      width: 100px;
      font-size: 12px;
      margin-bottom: 5px;
      .font-color {
        color: #1f1f1f;
      }
    }
  }
  .card-bottom {
    display: flex;
    margin-top: 40px;
    .card-run {
      color: #003aa3;
      padding-left: 20px;
      cursor: pointer;
    }
    .card-run:nth-child(2) {
      margin-left: 40px;
    }
    .run {
      background: url("~@/assets/img/rhythm/run@2x.png") no-repeat 0 2px / 15px
        15px;
    }
    .unrun {
      background: url("~@/assets/img/rhythm/unrun@2x.png") no-repeat 0 2px /
        15px 15px;
    }
  }
  ::v-deep .el-radio__label {
    display: none;
  }
}
</style>
